import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import "./index.scss";
import { setTemplate } from "../../../../actions/templates";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import Icon from "../../../common/Icon";
import EditorLeft from "./editorComponents/editorLeft";
import EditorRight from "./editorComponents/editorRight";
import { toast } from "react-toastify";
import axios from "axios";
import Input from "../../../common/Inputs";
import { tools } from "../newWritingTools";
import { v4 as uuidv4 } from "uuid";
import Loader from "../../../common/Loader";
import { LuHeart } from "react-icons/lu";
import { FaRegFileWord } from "react-icons/fa";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { FaRegFilePdf } from "react-icons/fa";

const TemplateEditor = ({
  clearTemplate,
  template,
  changeTemplate,
  auth: { user },
  recentContents
}) => {
  const [isOpenFirstVideo, setIsOpenFirstVideo] = useState(false)
  const [content, setContent] = useState('');
  const [words, setWords] = useState('');
  const [isSaved, setIsSaved] = useState(false);
  const [mainTools, setMainTools] = useState(tools);
  const history = useHistory();
  const [isLoadingTemplate,setIsLoadingTemplate] = useState(true)
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const BarRef = useRef(null);
  const [isOpenExpireModal,setIsOpenExpireModal] = useState(false);
  const location = useLocation();
  const [inputs, setInputs] = useState({
    name: "",
    content: "",
    voice: "",
    language: user && user.language ? user.language : "English",
    amount: 1,
    callToActionError: false
  });
  const handleSetWords = (splitedText, wordCount) => {
    setWords(prevState => {
      return prevState += ' ' + splitedText[wordCount]
   });
  };

  const handleCleanWords = () => {
    setWords('')
  };

  useEffect(()=>{
    if(!template.icon){
      GoBack()
    }else{
      setIsLoadingTemplate(false);
    };
  },[]);

  useEffect(() => {
    const templateId = location?.state?.templateId;

    if(templateId) {
      const findedTemplate = recentContents.find(template => template._id === templateId);
      setInputs(prevState => {
        return {
          ...prevState,
          content: findedTemplate?.productContent,
          name: findedTemplate?.name,
          voice: findedTemplate?.voice,
          callToAction: findedTemplate?.callToAction
        }
      });
      setContent(findedTemplate?.content ? findedTemplate?.content : '')
    } else {
      setInputs({
        name: "",
        content: "",
        voice: "",
        language: user && user.language ? user.language : "English",
        amount: 1,
      });
    }
  }, [user]);

  useEffect(() => {
    if (search.length) {
      setMainTools(tools.filter((e) =>  (e.title.toLowerCase()).includes(search.toLowerCase())));
    } else {
      setMainTools(tools);
    }
  }, [search]);

  const GoBack = () => {
    clearTemplate();
    history.goBack();
  };

  const handleInputChange = (name, value) => {    
    setInputs({
      ...inputs,
      [name]: value,
    });
  };

  const cleanButton = () => {
    setInputs({
      name: "",
      content: "",
      voice: "",
      language: user.language ? user.language : "English",
      amount: 1,
    });
    setContent('');
    setWords('')
  };
  const RefreshAndChangeTemplate = (newTemplate) => {
    changeTemplate(newTemplate);
    setContent('')
    cleanButton();
    BarRef.current.style.right = "-100%";
  };
  const handleSubmit = async (isReset) => {
    const urlPattenr = new RegExp(
      /^(https?:\/\/)([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/i
    );

    if(!urlPattenr.test(inputs.callToAction) && inputs.callToAction) {
      toast.error('Invalid http or https link.');
      setInputs(prevState => {
        return {
          ...prevState,
          callToActionError: true
        }
      })
    } else {
      setInputs(prevState => {
        return {
          ...prevState,
          callToActionError: false
        }
      })
      if (!inputs.content || !inputs.content.trim()) {
        toast.error('Please fill required fields')
        return
      }
      let titleP = inputs.name.length ? inputs.name + "," : "";
      let toneP = inputs.voice?.length
        ? `. Tone of voice is ${inputs.voice}.`
        : "";
      let lang = inputs.language.length
        ? `The output language is: ${inputs.language}.`
        : "";
      let callToAction = inputs.callToAction?.length
        ? `Add at the end of the text as a link: ${inputs.callToAction}.`
        : "";
  
      let apiPrompt = `${template.prompt} ${titleP}${inputs.content.trim()}${toneP} ${callToAction} ${lang}`;
  
      setIsLoading(true);
      try {
        const promise = await axios.post("/api/index/beastmode", {
          text: isReset ? apiPrompt : words || apiPrompt,
          engine: template.engine,
          token: template.token,
          runs: inputs.amount,
        });
  
        const list = promise.data["choices"];
        const connectText = list.reduce(
          (prev, next) => prev + next.text.replaceAll(/[\r\n]/gm, "<br>").replace(/^(<br\s*\/?>)+/g, ""),
          ""
        );
        
        let text = "";
        if (connectText[connectText.length - 1] === ".") {
          text = connectText;
        } else {
          text = connectText;
        }
        
        setContent(text);
        if(isReset) {
          setWords('');
        }
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        if(err && err.response && err.response.data && err.response.data.raw && err.response.data.raw.message){
          if(err.response.data.raw.message === 'You can not generate document'){
            setIsOpenExpireModal(true)
            return
          }
          toast.error(err.response.data.raw.message)
          return
        }
        toast.error("Something went wrong. Try again.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  };

  const handleSave = async (isNotSave) => {
    if(content) {
      try {
        const { data: { doc: { id } } } = await axios.post('api/documents', {
          title: template.title
        });
  
        const body = JSON.stringify({
          content,
          name: inputs.name,
          title: template.title,
          productContent: inputs.content,
          productName: inputs.name,
        });
  
        const config = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        const res = await axios.patch(`/api/documents/findone/${id}`, body, config);
        if(isNotSave !== 'notSave') {
          document.querySelectorAll('svg')[4].style.fill = '#5a64e7'
          toast.success('The template has been saved');
        }
        return id
      } catch(err) {
        console.error(err);
      }
    } else {
      toast.error("The template has not been saved.")
    }
  }

  const downloadPdfOrWord = async (temlateType) => {
    const documentId = await handleSave('notSave');

    if(documentId) {
      try {
        const response = await axios.get(`/api/documents/download-${temlateType}/${documentId}`, {
          responseType: "blob",
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${template.title}.${temlateType}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      } catch(err) {
        console.error(err);
      }
    }
  }

  const handleOpenVideo = () => {
    setIsOpenFirstVideo(true)
  }

  return (
    <div className="ai__editor">
      {isLoadingTemplate ? (<Loader />) : (
      <div className="wrapper">
        {isOpenFirstVideo && (
              <div className="videoPlayer">
                <div
                  className="closer"
                  role="presentation"
                  onClick={() => {
                    setIsOpenFirstVideo(false);
                  }}
                ></div>
                <iframe
                    width="90%"
                    height="90%"
                    src="https://player.vimeo.com/video/1025514060"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen={true}
                  ></iframe>
                {/* <div className="videoPlayer__video">
                  <video src={video} controls autoPlay></video>
                  <Icon name="Close" onClick={() => setIsOpenFirstVideo(false)} />
                </div> */}
              </div>
            )}
        <div className="ai__back" role="presentation" onClick={GoBack}>
          <Icon name="ArrowBack" />
          <span>Back</span>
        </div>
        <div className="editor__header">
          <div className="editor__header__left">
            <div className="icon">
              <Icon name={template.title === 'Paraphrase The Text' ? template.bigIcon : template.icon} />
            </div>
            <div className="editor__header__left__text">
              <div className="title">{template.title}</div>
              <div className="description">{template.description}</div>
            </div>
          </div>
          <div className="editor__header__right">
            <div className="actions__wrapper">
              <div
                className="bar__button"
                role="presentation"
                onClick={() => (BarRef.current.style.right = "0%")}
              >
                <Icon name="DoubleArrowLeft" />
                <span>Templates</span>
              </div>
              <div className="svg__wrapper">
                <button
                  onClick={handleOpenVideo}
                  className="btn-second"
                >
                  Watch Video
                </button>
                <FaRegFilePdf onClick={() => downloadPdfOrWord('pdf')} cursor='pointer' color='#5a64e7' />
                <FaRegFileWord onClick={() => downloadPdfOrWord('docx')} cursor='pointer' color='#5a64e7' />
                <LuHeart onClick={handleSave} cursor='pointer' color='#5a64e7' fill={'transparent'} />
              </div>
            </div>
            <div className="editor__hide__bar" ref={BarRef}>
              <div className="editor__hide__bar__wrapper">
                <Input
                  iconName="Search"
                  value={search}
                  onChange={(name, value) => setSearch(value)}
                />
                <div
                  className="editor__hide__bar__button"
                  role="presentation"
                  onClick={() => (BarRef.current.style.right = "-100%")}
                >
                  <Icon name="DoubleArrowLeft" />
                </div>
                <div className="editor__hide__bar__items">
                  {mainTools &&
                    mainTools.map((tool) => {
                      return (
                        <div
                          key={uuidv4()}
                          className="editor__hide__bar__item"
                          role="presentation"
                          onClick={() => RefreshAndChangeTemplate(tool)}
                        >
                          <div className="icon">
                            <Icon name={tool.icon} />
                          </div>
                          <div className="title">{tool.title}</div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="editor__content">
          <EditorLeft
            cleanButton={cleanButton}
            handleSubmit={handleSubmit}
            inputs={inputs}
            user={user}
            isOpenExpireModal={isOpenExpireModal}
            setIsOpenExpireModal={setIsOpenExpireModal}
            isLoading={isLoading}
            handleInputChange={handleInputChange}
            templateName={template.title}
          />
          <EditorRight
            content={content}
            handleReset={handleSubmit}
            title={template.title}
            isLoading={isLoading}
            handleSetWords={handleSetWords}
            words={words}
            handleCleanWords={handleCleanWords}
          />
        </div>
      </div>
      )}
    </div>
  );
};

TemplateEditor.propTypes = {
  clearTemplate: PropTypes.func,
  template: PropTypes.object,
  changeTemplate: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    template: state.template,
    recentContents: state.document.recentContents
  };
};

const mapDispatchToProps = (dispatch) => ({
  clearTemplate: () => dispatch(setTemplate({})),
  changeTemplate: (template) => dispatch(setTemplate(template)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TemplateEditor);
